var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.513916H0.996875C0.446875 0.513916 0 0.967041 0 1.52329V13.5045C0 14.0608 0.446875 14.5139 0.996875 14.5139H13C13.55 14.5139 14 14.0608 14 13.5045V1.52329C14 0.967041 13.55 0.513916 13 0.513916ZM4.23125 12.5139H2.15625V5.83267H4.23438V12.5139H4.23125ZM3.19375 4.92017C2.52812 4.92017 1.99063 4.37954 1.99063 3.71704C1.99063 3.05454 2.52812 2.51392 3.19375 2.51392C3.85625 2.51392 4.39687 3.05454 4.39687 3.71704C4.39687 4.38267 3.85938 4.92017 3.19375 4.92017ZM12.0094 12.5139H9.93437V9.26392C9.93437 8.48892 9.91875 7.49204 8.85625 7.49204C7.775 7.49204 7.60938 8.33579 7.60938 9.20767V12.5139H5.53438V5.83267H7.525V6.74517H7.55312C7.83125 6.22017 8.50938 5.66704 9.51875 5.66704C11.6187 5.66704 12.0094 7.05142 12.0094 8.85142V12.5139Z",
    fill: "#9CA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.350d731d7e237544bd68b4d38fcd7782.svg";
export { ForwardRef as ReactComponent };